<template>
    <v-card 
        class="mx-auto pa-4 pa-lg-6 d-flex flex-column justify-space-between custom-radius"
        height="100%"
    >
        <div class="text-center">
            <div class="overline mb-4" :class="`${status.color}--text`" v-if="status.value !== null">
                <span v-if="status.value == 0">Rejected</span>    
                <span v-else-if="status.value == 1">Pending</span>    
                <span v-else-if="status.value == 2">Approved</span>    
            </div>
            <template v-if="hasVotingEnded">
                <div class="text-center subtitle-1 font-weight-bold mb-4" v-if="bid.place === 1">
                    <img src="@/assets/images/medal-gold.svg" class="medal-icon lg" alt="">
                    <div v-text="$t('1stPlace')"></div>
                </div>
                <div class="text-center subtitle-1 font-weight-bold mb-4" v-else-if="bid.place === 2">
                    <img src="@/assets/images/medal-silver.svg" class="medal-icon lg" alt="">
                    <div v-text="$t('2ndPlace')"></div>
                </div>
                <div class="text-center subtitle-1 font-weight-bold mb-4" v-else-if="bid.place === 3">
                    <img src="@/assets/images/medal-bronze.svg" class="medal-icon lg" alt="">
                    <div v-text="$t('3rdPlace')"></div>
                </div>
            </template>
            <div class="title mt-4 mb-4 mb-lg-8" v-text="bid.title"></div> 
        </div>
        <div class="text-center px-4">
            <template v-if="inlineRating">
                <div class="d-flex align-center justify-space-between mb-6">
                    <div class="subtitle-1">{{ bid.avgRating }} ({{ bid.numOfRatings }} votes)</div>
                    <v-rating 
                        dense
                        readonly
                        half-increments
                        full-icon="mdi-star"
                        half-icon="mdi-star-half-full"
                        color="orange"
                        background-color="orange lighten-3"
                        :value="bid.avgRating"
                    ></v-rating>
                </div>
            </template>
            <template v-else>
                <div class="title" v-text="bid.avgRating"></div>
                <v-rating
                    readonly
                    half-increments
                    full-icon="mdi-star"
                    half-icon="mdi-star-half-full"
                    color="orange"
                    background-color="orange lighten-3"
                    :value="bid.avgRating"
                ></v-rating>
                <div class="body-1">({{ bid.numOfRatings }} votes)</div>
            </template>
            <div class="d-flex flex-column">
                <div class="c-chip mb-4" v-if="topic">
                    <span v-text="`${$t('Topic')}: `"></span>
                    <span v-text="topic"></span>
                </div>
                <div class="c-chip mb-4" v-if="date">
                    <span v-text="`${$t('Date')}: `"></span>
                    <span v-text="date"></span>
                </div>
            </div>
            <v-btn 
                depressed 
                rounded 
                color="primary" 
                class="mt-3 mt-lg-6" 
                :to="`/${$i18n.locale}/ecreative/bid/details/${bid.id}`"
                v-text="$t('Open')"
            ></v-btn>
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'bidCard',
        props: {
            bid: {
                type: Object,
                default: () => ({
                    id: null,
                    title: '',
                    description: '',
                    avgRating: 0,
                    numOfRatings: 0,
                    place: 0,
                })
            },
            hasVotingEnded: {
                type: Boolean,
                default: false
            },
            status: {
                type: Object,
                default: () => ({
                    value: null,
                    color: '',
                })
            },
            topic: {
                type: String,
                default: ''
            },
            date: {
                type: String,
                default: ''
            },
            inlineRating: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style lang="scss" scoped>
.medal-icon{
    &.lg{
        width: 80px;
    }
}
.c-chip{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    border-radius: 16px;
    border: 1px solid $primary;
    color: $primary;
    font-size: 14px;
    line-height: 20px;
}
</style>